import { render, staticRenderFns } from "./PoliticaPrivacidade.vue?vue&type=template&id=7e7f6268&"
import script from "./PoliticaPrivacidade.vue?vue&type=script&lang=js&"
export * from "./PoliticaPrivacidade.vue?vue&type=script&lang=js&"
import style0 from "./PoliticaPrivacidade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports